import * as Sentry from '@sentry/nextjs';
import 'client-only';

export async function traceListingImportBatch<T>(
  fileCount: number,
  run: () => Promise<T>
): Promise<T> {
  try {
    return await Sentry.startSpan(
      {
        name: 'listing.import.batch',
        op: 'listing.import.batch',
        attributes: { fileCount },
      },
      run
    );
  } catch {
    return run();
  }
}
